import { Banner, EmptyBanner } from "../stores/BannerStore";

import React from "react";
import Responsive from "react-responsive";
import { ResponsiveImages } from "./BannerContainer";

// In case of changing values, they must be changed in _config.scss, FullPageBanner-test.js, Ad-test.js, HeroBanner-test.js as well.
const desktopBreakpoint = 1024;
const tabletBreakpoint = 321;
const mobileBreakpoint = 1;

export const Desktop = (props: Object) => <Responsive {...props} minWidth={desktopBreakpoint + 1} />;
export const Tablet = (props: Object) => (
    <Responsive {...props} minWidth={tabletBreakpoint + 1} maxWidth={desktopBreakpoint} />
);
export const Mobile = (props: Object) => <Responsive {...props} maxWidth={tabletBreakpoint} />;

export function getAdImages(banner: Banner) {
    return banner.images.map<ResponsiveImages>(image => {
        const tabletBP = image.mobile ? tabletBreakpoint : "0";
        const desktopBP = image.tablet ? desktopBreakpoint : tabletBreakpoint;

        const images = {} as { [x: string]: string };
        // default image which is displayed until the correct image is loaded. If the mobile image is
        // the default banner, that image is displayed until the big desktop image is loaded on IE

        images["0"] = "/ordercapture/uidispatcher/static/app/assets/images/empty_banner_image.gif";
        if (image.mobile) {
            images["1"] = image.mobile.imageUrl;
        }
        if (image.tablet) {
            images[tabletBP] = image.tablet.imageUrl;
        }
        if (image.desktop) {
            images[desktopBP] = image.desktop.imageUrl;
        }

        return images;
    });
}

export function isEmptyBanner(bannerSpec: Banner | EmptyBanner) {
    if ((bannerSpec as EmptyBanner).isEmpty !== undefined) {
        return (bannerSpec as EmptyBanner).isEmpty;
    }
    return false;
}

export function getScreenType() {
    if (window.innerWidth >= desktopBreakpoint) {
        return "desktop";
    } else if (window.innerWidth >= tabletBreakpoint) {
        return "tablet";
    } else if (window.innerWidth < tabletBreakpoint) {
        return "mobile";
    }
    return "unknown";
}

export function getDesktopBreakpoint() {
    return desktopBreakpoint;
}

export function getTabletBreakpoint() {
    return tabletBreakpoint;
}

export function getMobileBreakpoint() {
    return mobileBreakpoint;
}
